export const ADMIN_NAV_BINGO = "Bingo";
export const ADMIN_NAV_BINGO_GAMES = "Bingo Games";
export const ADMIN_NAV_BINGO_GRIDS = "Bingo Grids";
export const ADMIN_NAV_BINGO_TEMPLATES = "Bingo Templates";
export const ADMIN_NAV_CLICK_AND_COLLECT = "Click & Collect";
export const ADMIN_NAV_DIAPORAMAS = "Slideshow";
export const ADMIN_NAV_EVENTS = "Events";
export const ADMIN_NAV_CROSSBAR = "Crossbar challenge";
export const ADMIN_NAV_QUIZZES = "Quizzes";
export const ADMIN_NAV_WORKFORCE = "Staff";
export const ADMIN_NAV_HTML_PAGE = "HTML Page";
export const ADMIN_NAV_VOTE = "Vote";
export const ADMIN_NAV_ROULETTE = "Roulette";
export const ADMIN_LOGOUT = "Logout";
export const ADMIN_NAV_PLACES = "Places";
export const ADMIN_NAV_PRONOSTICSV2 = "Pronostics";
export const ADMIN_NAV_CHAMPIONSHIPS = "Championships";
export const ADMIN_NAV_SONOMETER = "Sonometer";

// Collapsible admin nav
export const ADMIN_NAV_COLLAPSE_GAMES = "Modules";
export const ADMIN_NAV_COLLAPSE_SETTINGS = "Settings";

export const BLINDTEST_WAITING_MSG = "En attente de la prochaine question";
export const BLINDTEST_WAITING_RESULT_MSG = "Calcul du vainqueur en cours";

export const CROSSBAR_DEFAULT_GO_HOME = "Retourner à l'accueil";
export const CROSSBAR_DEFAULT_LOOSER_EXPLANATION_MSG =
  "Vous aurez plus de chances la prochaine fois !";
export const CROSSBAR_DEFAULT_LOOSER_MSG = "C'est perdu !";
export const CROSSBAR_DEFAULT_TRY_AGAIN_MSG =
  "Vous ne pouvez jouer qu'une seule fois. Merci d'avoir participé !";
export const CROSSBAR_DEFAULT_GOALKEEPER_CHOICE_MSG =
  "Quel gardien souhaitez-vous défier ?";
export const CROSSBAR_DEFAULT_PLAY = "Jouer";
export const CROSSBAR_DEFAULT_SELECT = "Sélectionner";
export const CROSSBAR_DEFAULT_SHOOT = "Tirer";
export const CROSSBAR_DEFAULT_TOO_LATE = "C'est terminé !";
export const CROSSBAR_DEFAULT_WAITING_MSG = "Faut attendre !";
export const CROSSBAR_DEFAULT_WELCOME_HEADER_MSG =
  "Bienvenue dans le jeu de la crossbar";
export const CROSSBAR_DEFAULT_WELCOME_CONTENT_MSG =
  "Pour être sélectionné, il faut marquer un pénalty à l'un de nos gardiens.";
export const CROSSBAR_DEFAULT_WELCOME_FOOTER_MSG =
  "Prêt à tenter votre chance ?";
export const CROSSBAR_DEFAULT_WINNER_MSG = "C'est gagné !";
export const CROSSBAR_DEFAULT_WINNER_EXPLANATION_MSG =
  "Vous allez être contacté par l'équipe organisatrice !";

/** GOALKEEPER RIGHT */
export const CROSSBAR_DEFAULT_GOALKEEPER_RIGHT_NAME = "JANNICK GREEN";
export const CROSSBAR_DEFAULT_GOALKEEPER_RIGHT_PHOTO =
  "/psg/crossbar/images/goalkeeper_right_photo.png";
export const CROSSBAR_DEFAULT_GOALKEEPER_RIGHT_INTRO_VIDEO =
  "/psg/crossbar/videos/goalkeeper_right_intro_video.mp4";
export const CROSSBAR_DEFAULT_GOALKEEPER_RIGHT_GOAL_UPPER_LEFT_VIDEO =
  "/psg/crossbar/videos/goalkeeper_right_goal_upper_left_video.mp4";
export const CROSSBAR_DEFAULT_GOALKEEPER_RIGHT_GOAL_UPPER_RIGHT_VIDEO =
  "/psg/crossbar/videos/goalkeeper_right_goal_upper_right_video.mp4";
export const CROSSBAR_DEFAULT_GOALKEEPER_RIGHT_GOAL_DOWN_LEFT_VIDEO =
  "/psg/crossbar/videos/goalkeeper_right_goal_down_left_video.mp4";
export const CROSSBAR_DEFAULT_GOALKEEPER_RIGHT_GOAL_DOWN_RIGHT_VIDEO =
  "/psg/crossbar/videos/goalkeeper_right_goal_down_right_video.mp4";
export const CROSSBAR_DEFAULT_GOALKEEPER_RIGHT_MISSED_UPPER_LEFT_VIDEO =
  "/psg/crossbar/videos/goalkeeper_right_missed_upper_left_video.mp4";
export const CROSSBAR_DEFAULT_GOALKEEPER_RIGHT_MISSED_UPPER_RIGHT_VIDEO =
  "/psg/crossbar/videos/goalkeeper_right_missed_upper_right_video.mp4";
export const CROSSBAR_DEFAULT_GOALKEEPER_RIGHT_MISSED_DOWN_LEFT_VIDEO =
  "/psg/crossbar/videos/goalkeeper_right_missed_down_left_video.mp4";
export const CROSSBAR_DEFAULT_GOALKEEPER_RIGHT_MISSED_DOWN_RIGHT_VIDEO =
  "/psg/crossbar/videos/goalkeeper_right_missed_down_right_video.mp4";

/** GOALKEEPER LEFT */
export const CROSSBAR_DEFAULT_GOALKEEPER_LEFT_NAME = "ANDREAS PALICKA";
export const CROSSBAR_DEFAULT_GOALKEEPER_LEFT_PHOTO =
  "/psg/crossbar/images/goalkeeper_left_photo.png";
export const CROSSBAR_DEFAULT_GOALKEEPER_LEFT_INTRO_VIDEO =
  "/psg/crossbar/videos/goalkeeper_left_intro_video.mp4";
export const CROSSBAR_DEFAULT_GOALKEEPER_LEFT_GOAL_UPPER_LEFT_VIDEO =
  "/psg/crossbar/videos/goalkeeper_left_goal_upper_left_video.mp4";
export const CROSSBAR_DEFAULT_GOALKEEPER_LEFT_GOAL_UPPER_RIGHT_VIDEO =
  "/psg/crossbar/videos/goalkeeper_left_goal_upper_right_video.mp4";
export const CROSSBAR_DEFAULT_GOALKEEPER_LEFT_GOAL_DOWN_LEFT_VIDEO =
  "/psg/crossbar/videos/goalkeeper_left_goal_down_left_video.mp4";
export const CROSSBAR_DEFAULT_GOALKEEPER_LEFT_GOAL_DOWN_RIGHT_VIDEO =
  "/psg/crossbar/videos/goalkeeper_left_goal_down_right_video.mp4";
export const CROSSBAR_DEFAULT_GOALKEEPER_LEFT_MISSED_UPPER_LEFT_VIDEO =
  "/psg/crossbar/videos/goalkeeper_left_missed_upper_left_video.mp4";
export const CROSSBAR_DEFAULT_GOALKEEPER_LEFT_MISSED_UPPER_RIGHT_VIDEO =
  "/psg/crossbar/videos/goalkeeper_left_missed_upper_right_video.mp4";
export const CROSSBAR_DEFAULT_GOALKEEPER_LEFT_MISSED_DOWN_LEFT_VIDEO =
  "/psg/crossbar/videos/goalkeeper_left_missed_down_left_video.mp4";
export const CROSSBAR_DEFAULT_GOALKEEPER_LEFT_MISSED_DOWN_RIGHT_VIDEO =
  "/psg/crossbar/videos/goalkeeper_left_missed_down_right_video.mp4";

export const EVENT_CONTACT_FORM_CHECKBOX_LINK = "Disponible ici.";
export const EVENT_CONTACT_FORM_CHECKBOX_MESSAGE =
  "J'accepte le règlement du Paris St-Germain";
export const EVENT_CONTACT_FORM_THANKS =
  "Le Paris Saint-Germain Handball <br /> vous remercie pour votre soutien et votre fidélité.";
export const EVENT_CONTACT_FORM_VALIDATION_BUTTON = "Valider";
export const EVENT_CONTACT_FORM_WELCOME =
  "Cher supporter bienvenue ! <br/> Pour profiter de l'ensemble de l'expérience, <br/> veuillez remplir le formulaire ci-joint.";
export const EVENT_HEADER_FIRST_OPPONENT = "PARIS SAINT-GERMAIN";
export const EVENT_LANDING_MSG =
  "<span>PROFITEZ DE LA FAN EXPÉRIENCE</span><span>DU PARIS SAINT-GERMAIN HANDBALL</span><span>AVANT, PENDANT ET APRÈS LE MATCH !</span>";
export const EVENT_MENU_CLICK_AND_COLLECT = "MENU BUVETTE";
export const EVENT_MENU_KICKOFF = "KICK OFF";
export const EVENT_MENU_MAN_OF_THE_MATCH = "VOTEZ POUR L'HOMME DU MATCH";
export const EVENT_MENU_MESSAGES = "ENCOURAGEZ <br /> VOS <br /> JOUEURS";
export const EVENT_MENU_QUIZ = "JOUEZ <br /> AU QUIZ <br /> MI-TEMPS";
export const EVENT_MENU_QUESTIONS = "QUESTIONS INVITES";
export const EVENT_MENU_PRONOSTICS = "FAITES VOS PRONOSTICS";

export const FORM_VALIDATION_FIRST_NAME_REQUIRED = "Prénom requis.";
export const FORM_VALIDATION_LAST_NAME_REQUIRED = "Nom requis.";
export const FORM_VALIDATION_EMAIL_NOT_VALIDATED = "Email invalide.";
export const FORM_VALIDATION_PHONE_NOT_VALIDATED =
  "Numéro de téléphone valide requis.";
export const FORM_VALIDATION_TERMS_OF_SERVICE =
  "Vous devez accepter le règlement général pour continuer.";

export const MAN_OF_THE_MATCH_ALREADY_VOTED =
  "Merci d'avoir voté ! Revenez une fois le vote terminé pour voir le résultat.";
export const MAN_OF_THE_MATCH_IN_PROGESS = "Désignez votre homme du match !";
export const MAN_OF_THE_MATCH_NOT_STARTED =
  "Il n'est pas encore possible de voter pour l'homme du match.";

export const NAV_BINGO = "Bingo";
export const NAV_CLICK_AND_COLLECT = "Menu buvette";
export const NAV_CROSSBAR = "Crossbar challenge";
export const NAV_MAN_MATCH = "Homme du match";
export const NAV_PRONOS = "Pronos";
export const NAV_QUESTIONS = "Questions";
export const NAV_QUIZ = "Quiz mi-temps";
export const NAV_SELFIES_MSG = "Selfies et messages";
export const NAV_TITLE = "Menu";
export const NAV_HTML_PAGE = "HTML Page";
export const NAV_HTML_PAGE_TWO = "HTML Page No2";
export const NAV_PRONOSTICSV2 = "Pronostics";
export const NAV_FOOD_MENU_V2 = "Food Menu V2";

export const QUIZ_ADMIN_MISSING_WINNER_TEMPLATE =
  "Chaîne de caractère #WINNER# manquante";
export const QUIZ_ADMIN_WRONG_QUESTION_FORMAT =
  "Réponse invalide, doit être un nombre entier.";

export const QUIZ_GAME_DEFAULT_ENDING_MOBILE_MSG =
  "Le quiz est terminé, merci d'avoir participé !";
export const QUIZ_GAME_DEFAULT_WINNER_PRIVATE_MSG =
  "Félicitations ! Vous allez être contacté par l'équipe organisatrice";
export const QUIZ_GAME_DEFAULT_ENDING_SCREEN_MSG =
  "Le quiz est terminé !<br> C'est #WINNER# qui le remporte !";
export const QUIZ_GAME_DEFAULT_WAITING_MOBILE_MSG =
  "Le quiz va bientôt commencer.";
export const QUIZ_GAME_SCREEN_DEFAULT_WINNER_MSG =
  "Le vainqueur va être contacté par équipe organisatrice";
export const QUIZ_GAME_NOT_CONNECTED =
  "LE QUIZ EST RÉSERVÉ AUX <br/> SPECTATEURS QUI SONT PRÉSENTS <br/> EN TRIBUNE LE JOUR DE LA RENCONTRE.";
export const QUIZ_GAME_OVER =
  "Le quiz est terminé !<br/> En attente des résultats.";
export const QUIZ_GAME_RESULT_CALCULATION = "Calcul des résultats en cours";
export const WALL_BUTTON = "Rafraîchir";
export const WALL_WAITING_MESSAGE =
  "L'envoi des messages n'est pas encore ouvert";
export const WALL_QUESTIONS_WAITING_MESSAGE =
  "L'envoi des questions est terminé. Profitez du match !";

export const BINGO_GAME_NOT_CONNECTED =
  "LE BINGO EST RÉSERVÉ AUX <br/> SPECTATEURS QUI SONT PRÉSENTS <br/> EN TRIBUNE LE JOUR DE LA RENCONTRE.";

export const HTML_PAGE_NOT_AVAILABLE =
  "CETTE PAGE EST RÉSERVÉE AUX <br/> SPECTATEURS PRÉSENTS <br/> EN TRIBUNE LORS DE L'ÉVÉNEMENT.";

export const POST_MESSAGE_FORM_TEXTS = {
  // Error messages
  UPLOAD_ERROR_TITLE: "Oups",
  UPLOAD_ERROR_MESSAGE:
    "Impossible d'envoyer ton message pour l'instant. Réessaye plus tard !",

  // Camera related texts
  CAMERA_PERMISSION_REQUESTING: "Demande d'autorisation d'accès à la caméra...",
  CAMERA_PERMISSION_INSTRUCTION:
    "Veuillez autoriser l'accès à la caméra lorsque vous y êtes invité.",
  CAMERA_LOADING: "Chargement de la caméra...",
  CAMERA_ERROR_TITLE: "Erreur d'accès à la caméra",
  CAMERA_PERMISSION_DENIED_TITLE: "Permission refusée",
  CAMERA_PERMISSION_DENIED_MESSAGE:
    "L'accès à la caméra a été bloqué. Veuillez autoriser l'accès dans les paramètres de votre navigateur.",
  CAMERA_BROWSER_NOT_SUPPORTED:
    "Votre navigateur ne supporte pas l'accès à la caméra",
  CAMERA_NO_CAMERA_FOUND: "Aucune caméra n'a été trouvée sur votre appareil.",
  CAMERA_ALREADY_IN_USE:
    "La caméra est déjà utilisée par une autre application.",
  CAMERA_GENERIC_ERROR: "Impossible d'accéder à la caméra. Veuillez réessayer.",

  // Camera permission prompts
  CAMERA_PERMISSION_PROMPT:
    "Vous devez autoriser l'accès à la caméra pour prendre une photo.",
  CAMERA_PERMISSION_BUTTON: "Autoriser l'accès à la caméra",
  CAMERA_PERMISSION_HELP:
    "Pour autoriser l'accès à la caméra, allez dans les paramètres de votre navigateur et réinitialisez les permissions pour ce site.",

  // Camera actions
  CAPTURE_PHOTO_BUTTON: "Prendre la photo",
  CANCEL_CAMERA_BUTTON: "Annuler",
  USE_FILE_SELECTOR_BUTTON: "Utiliser le sélecteur de fichiers",
  FLIP_CAMERA_BUTTON: "Flip Camera",
  FRONT_CAMERA: "Front Camera",
  BACK_CAMERA: "Back Camera",

  // File input
  PHOTO_LABEL: "Photo",
  ADD_PHOTO_PLACEHOLDER: "Ajoutez votre photo",
  ADD_PHOTO_LABEL: "Ajoutez votre photo",
  PHOTO_CAPTURED_PLACEHOLDER: "Photo capturée",
  TAKE_PHOTO_BUTTON: "Prendre une photo avec l'appareil photo",
  CAMERA_ACCESS_BLOCKED: "Accès à la caméra bloqué",

  // Image preview
  IMAGE_PREVIEW_ALT: "Aperçu de la photo",

  // Submit button
  SUBMIT_BUTTON: "Envoyer",
} as const;
